export default __webpack_public_path__ + "static/media/buyBestBanner4.edb53e93.png";